import React, { useState } from 'react'
import RenderInput from '../RenderInput/RenderInput'
import RenderEditModal from '../RenderEditModal/RenderEditModal';
import './styles.css'

const ADVISORY_FEE_COLUMN = 'advisory_fee'

const RenderEdit = ({ style, value, curr, columnName, columnLabel, name, token, component, unit, isSuperAdmin }) => {
    
    const isEditButton = isSuperAdmin || columnName === ADVISORY_FEE_COLUMN;
    const [unitSymbol, setUnitSymbol] = useState(unit);
    const [open, setIsOpen] = useState(false);
    const { tda_account_number: accountNumber, acct_index: accountIndex, user: { username } } = curr;

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);
    const handleOnClick = (e) => {
        if(e.ctrlKey || e.metaKey) {
            openModal();
        }
    }

    const handleOnUnitButtonClick = () => {
        setUnitSymbol(prev => prev === '$' ? 'bp' : '$');
    }

    return (
        <div style={{ ...style, display: 'flex' }}>
            <div style={{ flex: '1 1 auto' }} onClick={handleOnClick}>
                <RenderInput 
                    value={value} 
                    component={component} 
                    token={token} 
                    accountIndex={accountIndex} 
                    username={username} 
                    columnLabel={columnLabel} 
                    columnName={columnName}
                    unit={unitSymbol}
                    isEditButton={isEditButton}
                />
            </div>

            {isEditButton && <button className='unit-button' onClick={handleOnUnitButtonClick}>{unitSymbol}</button>}

            
            {isEditButton && 
                <RenderEditModal
                isOpen={open}
                closeModal={closeModal}
                columnLabel={columnLabel}
                columnName={columnName}
                accountNumber={accountNumber}
                name={name}
                token={token}
                accountIndex={accountIndex}
                username={username}
                component={component}
                setUnitSymbol={setUnitSymbol}
                />
            }
            
        </div>
    )
}

export default RenderEdit